export default __webpack_public_path__ + "static/media/wac01.5c7f4fa6.jpg";